import * as Yup from "yup";

export const price = Yup.string().required("این فیلد اجباری است").optional();

export const address = Yup.string()
  .matches(/^[\u0600-\u06FF0-9-,._( )\s]+$/, "آدرس را فارسی تایپ کنید")
  .required("فیلد آدرس اجباری است");

export const kartNumber = Yup.string().matches(
  /^\d{16}$/,
  "شماره کارت را به درستی وارد کنید"
);
// .required("این فیلد اجباری است");

export const shabaNumber = Yup.string().matches(
  /^\d{24}$/,
  "شماره شبا را به درستی وارد کنید"
);
// .required("این فیلد اجباری است");

export const nationalCode = Yup.string()
  .matches(/^[0-9]{10}$/, "کدملی اشتباه است")
  .required("این فیلد اجباری است");
export const nationalId = Yup.string()
  .matches(/^[0-9]{11}$/, "شناسه ملی اشتباه است")
  .required("این فیلد اجباری است");
export const registrationNumber = Yup.string()
  .matches(/^[0-9]{3,15}$/, "شماره ثبت اشتباه است")
  .required("این فیلد اجباری است");

export const telephone = Yup.string()
  .matches(/^\d{11}$/, "شماره تلفن اشتباه است")
  .required("این فیلد اجباری است");

export const firstName = Yup.string()
  .min(2, "بیشتر از 2 حرف وارد کنید")
  .matches(/^[\u0600-\u06FF ]+$/, "از کاراکترهای مجاز استفاده کنید")
  .required("این فیلد اجباری است");

export const lastName = Yup.string()
  .min(2, "بیشتر از 2 حرف وارد کنید")
  .matches(/^[\u0600-\u06FF ]+$/, "از کاراکترهای مجاز استفاده کنید")
  .required("این فیلد اجباری است");

export const phoneNumber = Yup.string()
  .matches(/^(09\d{9}|9\d{9})$/, "شماره موبایل اشتباه است")
  .required("این فیلد اجباری است");
export const expire = Yup.string().required("این فیلد اجباری است");

export const schoolName = Yup.string()
  .min(2, "بیشتر از 2 حرف وارد کنید")
  .matches(/^[\u0600-\u06FF ()]+$/, "از کاراکترهای مجاز استفاده کنید")
  .required("این فیلد اجباری است");
